import React from 'react';
import { Box } from '@mui/material';
import FieldRow from './FieldRow';
import SectionBlock from './SectionBlock';
import ImagePreview from './ImagePreview';
import { formatMinor } from './buildComparisonRows';
import { fmtLocalDate } from '../../../utils/dateUtils';


export default function FreeTrialItemDetailPanel({ data, diffKeys = new Set(), side, lookups }) {
  if (!data) return null;

  const isPackage = data.packageId != null;
  const price = data.price ? formatMinor(data.price.baseCost, data.price.currencyId, lookups) : null;
  const campaign = data.campaign;

  return (
    <Box>
      <SectionBlock title="Free Trial Eligibility" />
      <FieldRow
        label={isPackage ? 'Package' : 'Item'}
        value={
          isPackage
            ? data.packageName ?? `Package ${data.packageId}`
            : data.itemName ?? (data.itemId != null ? `Item ${data.itemId}` : null)
        }
        isChanged={diffKeys.has('itemId') || diffKeys.has('packageId')}
        side={side}
      />
      {price && <FieldRow label="Price" value={price} side={side} />}
      {data.thumbnailUrl && (
        <Box sx={{ px: 2, pb: 1 }}>
          <ImagePreview url={data.thumbnailUrl} width={96} height={64} />
        </Box>
      )}

      {campaign !== undefined && (
        <>
          <SectionBlock title="Campaign" />
          {campaign ? (
            <>
              <FieldRow label="Window" value={`${fmtLocalDate(campaign.startAt)} – ${fmtLocalDate(campaign.endAt)}`} side={side} />
              <FieldRow
                label="Status"
                value={`${campaign.isEnabled ? 'Enabled' : 'Disabled'} · ${campaign.status ?? 'unknown'}`}
                side={side}
              />
            </>
          ) : (
            <FieldRow label="Campaign" value="None yet" side={side} />
          )}
        </>
      )}
    </Box>
  );
}
